import React from "react";

import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

function Responsive(props) {
  const { children, mobile, normal } = props;
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'), { noSsr: true });

  if ((normal && !matches) || (mobile && matches)) {
    return children;
  }

  return <></>;
}

const IsMobile = () => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'), { noSsr: true });
  return matches;
};

const mobileBounds = () => {
  return window.innerWidth < 600;
};

const IsMedium = () => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('md'), { noSsr: true });
  return matches;
};

export { Responsive, IsMobile, mobileBounds, IsMedium };
